import React from 'react'

function Approach() {
  return (
    <>
    <div className='bg-[#e4e4e4]'>
        <div className='max-w-screen-xl mx-auto justify-center md:px-10 px-5 md:py-32 py-12'>
            <div className='justify-center mx-auto items-center'>
                <h1 className='md:text-4xl text-2xl mx-auto text-[#000]'>
                    Our Approach
                </h1>
            </div>
            <div className='mx-auto md:pt-8 pt-3 text-[#757575]'>
                <div className='tracking-wide justify-center'>
                    <p className='md:text-base text-sm'>
                        Our cybersecurity services are built on a foundation of comprehensive risk assessment, cutting-edge technology, and a deep understanding of the cyber threat landscape. We provide end-to-end security solutions that encompass threat detection, prevention, and response strategies, ensuring your business remains resilient in the face of cyber challenges.
                    </p>
                </div>
            </div>
        </div>
    </div>
    </>
  )
}

export default Approach